<template>
  <div class="home">
    <div class="fullPage" ref="fullPage">
      <div
        class="fullPageContainer"
        ref="fullPageContainer"
        @mousewheel="mouseWheelHandle"
        @DOMMouseScroll="mouseWheelHandle"
        @touchstart="handleTouchstart"
        @touchend="handleTouchend"
        @touchmove="handleTouchmove"
      >
        <div class="section section1">
          <el-carousel height="calc(100vh - 80px)">
            <el-carousel-item v-for="(item, index) in bannerList" :key="index">
              <a :href="item.customUrl">
                <img
                  class="img"
                  :src="item.objectKey"
                  alt=""
                  style="width: 100%; height: 100%"
                  loading="lazy"
                />
              </a>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div
          class="section section2"
          :class="{ active: fullpage.current == 2 }"
        >
          <div class="main">
            <div class="byteStandard content-item-block">
              <div class="title">
                <div class="cont_tit">
                  <p>导航</p>
                  <span>Navigation</span>
                </div>
              </div>
            </div>
            <div ref="banner" class="banner content-item-block">
              <div class="banner-left">
                <ul class="category">
                  <li
                    class="category-item"
                    v-for="(item, index) in menuList"
                    :key="item.reIndustryTreeId"
                    :class="{ selected: selectedIndex === index }"
                    @mouseover="handleMouseOver(index)"
                    @mouseout="handleMouseOut"
                  >
                    <p class="category-left">
                      <span
                        class="category-title"
                        v-if="item.children.length > 0"
                        >{{ item.industryName }}</span
                      >
                      <span
                        v-if="item.children.length > 0"
                        role="img"
                        aria-label="right"
                        class="anticon anticon-right icon-enter"
                        ><svg
                          viewBox="64 64 896 896"
                          focusable="false"
                          data-icon="right"
                          width="1em"
                          height="1em"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            d="M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"
                          ></path>
                        </svg>
                      </span>
                      <router-link class="category-title" v-else to="/jobs"
                        >{{ item.industryName }}
                      </router-link>
                    </p>
                    <div
                      class="category-content"
                      :class="{
                        'hover-visible':
                          selectedIndex === index && item.children.length > 0,
                      }"
                    >
                      <div class="content-title">{{ item.industryName }}</div>
                      <div class="content-all">
                        <router-link
                          v-for="ite in item.children"
                          :key="ite.reIndustryTreeId"
                          :to="{
                            path: '/jobs',
                            query: { keyword: ite.industryName },
                          }"
                          class="content-item"
                        >
                          {{ ite.industryName }}
                        </router-link>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="banner-center">
                <el-carousel :interval="5000" arrow="always" height="450px">
                  <el-carousel-item
                    v-for="(item, index) in bannerList"
                    :key="index"
                  >
                    <a :href="item.customUrl">
                      <img class="img" :src="item.objectKey" alt="" />
                    </a>
                  </el-carousel-item>
                </el-carousel>
              </div>
              <div class="banner-right">
                <div class="Login" v-if="!state.isLogin">
                  <div class="flex-container">
                    <span class="flex-left active">找工作</span>
                    <a href="https://zp.hubeipeople.com/" target="_blank">
                      <span class="flex-right">找人才</span>
                    </a>
                  </div>
                  <div class="fillout">
                    <el-form
                      v-if="show"
                      ref="userForm"
                      :model="userForm"
                      :rules="userRules"
                      class="login-form"
                    >
                      <el-form-item prop="phoneNumber">
                        <el-input
                          v-model="userForm.phoneNumber"
                          type="text"
                          maxlength="11"
                          suffix-icon="el-icon-mobile-phone"
                          placeholder="手机号"
                        >
                        </el-input>
                      </el-form-item>
                      <el-form-item prop="verifyCode">
                        <el-input
                          style="width: 45%"
                          v-model="userForm.verifyCode"
                          type="text"
                          maxlength="6"
                          suffix-icon="el-icon-lock"
                          placeholder="验证码"
                        >
                        </el-input>
                        <el-button
                          style="width: 50%; margin-left: 5%"
                          class="btn-orange"
                          type="primary"
                          :disabled="disabled"
                          @click="getVerifyCode"
                          >{{ valiBtn }}</el-button
                        >
                      </el-form-item>
                      <el-form-item style="width: 100%">
                        <el-button
                          :loading="loading"
                          size="medium"
                          type="primary"
                          style="width: 100%"
                          @click.native.prevent="handleUserLogin"
                        >
                          <span v-if="!loading">登 录</span>
                          <span v-else>登 录 中...</span>
                        </el-button>
                        <div style="float: right" v-if="register">
                          <el-button
                            type="text"
                            class="link-type"
                            @click="getShow"
                            >微信登录</el-button
                          >
                          <el-button
                            type="text"
                            class="link-type"
                            @click="getClick"
                            >密码登录</el-button
                          >
                        </div>
                      </el-form-item>
                    </el-form>
                    <el-form
                      v-if="!show"
                      ref="userForm"
                      :model="userForm"
                      :rules="userRules"
                      class="login-form"
                    >
                      <el-form-item prop="phoneNumber">
                        <el-input
                          v-model="userForm.phoneNumber"
                          type="text"
                          maxlength="11"
                          suffix-icon="el-icon-mobile-phone"
                          placeholder="手机号"
                        >
                        </el-input>
                      </el-form-item>
                      <el-form-item prop="userPassword">
                        <el-input
                          v-model="userForm.userPassword"
                          type="password"
                          suffix-icon="el-icon-lock"
                          placeholder="密码"
                        >
                        </el-input>
                      </el-form-item>
                      <el-form-item style="width: 100%">
                        <el-button
                          :loading="loading"
                          size="medium"
                          type="primary"
                          style="width: 100%"
                          @click.native.prevent="handleRecord"
                        >
                          <span v-if="!loading">登 录</span>
                          <span v-else>登 录 中...</span>
                        </el-button>
                        <div style="float: right" v-if="register">
                          <div>
                            <el-button
                              type="text"
                              class="link-type"
                              @click="getShow"
                              >微信登录</el-button
                            >
                            <el-button
                              type="text"
                              class="link-type"
                              @click="getClick"
                              >验证码登录</el-button
                            >
                          </div>
                          <div>
                            <router-link class="link-type" to="/register"
                              >立即注册</router-link
                            >
                            <router-link
                              class="link-type"
                              style="margin-left: 10px"
                              to="/forgotPassword"
                              >忘记密码</router-link
                            >
                          </div>
                        </div>
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
                <div class="Login" v-else>
                  <img
                    v-if="state.profilePhoto"
                    :src="state.profilePhoto"
                    alt=""
                    class="avatar"
                  />
                  <img
                    v-else
                    src="../assets/images/tx.jpeg"
                    alt=""
                    class="avatar"
                  />
                  <input
                    type="file"
                    class="file"
                    accept=".jpg,.jpeg,.png"
                    @change="handleFileChange"
                  />
                  <p class="userInfo">
                    欢迎您,{{ state.userName || state.phoneNumber }} !
                  </p>
                  <ul class="user-tab">
                    <li class="tab-item">
                      <router-link to="/resume">我的简历</router-link>
                    </li>
                    <li class="tab-item">
                      <router-link to="/jobSearchProgress"
                        >求职进展</router-link
                      >
                    </li>
                    <li class="tab-item">
                      <router-link to="/forgotPassword"
                        >设置/修改密码</router-link
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="section section3"
          :class="{ active: fullpage.current == 3 }"
        >
          <div class="main">
            <div class="byteStandard content-item-block">
              <div class="title">
                <div class="cont_tit">
                  <p>新闻中心</p>
                  <span>News Center</span>
                </div>
              </div>
            </div>
            <div class="ttxw">
              <img src="../assets/images/index20231114_9.png" alt="" />
              <router-link
                :to="'/content/' + ModeTab + '/' + comment.cmCommentId"
              >
                {{ comment.commentTitle }}
              </router-link>
            </div>
            <div ref="product" class="product content-item-block">
              <div class="left_cont">
                <div class="lis">
                  <router-link
                    :to="'/content/' + ModeTab + '/' + comment.cmCommentId"
                  >
                    <img :src="comment.objectKey" alt="" />
                    <p>{{ comment.commentTitle }}</p>
                  </router-link>
                </div>
              </div>
              <div class="right_cont">
                <div class="tis-tab">
                  <div
                    v-for="(item, index) in tabs"
                    :key="index"
                    class="tab-item"
                    :class="{ 'item--active': ModeTab == index + 1 }"
                    @mouseover="toggleLoginModeTab(index + 1)"
                  >
                    <router-link
                      :to="{
                        path: '/announcement',
                        query: { announcementId: ModeTab },
                      }"
                    >
                      {{ item }}
                    </router-link>
                  </div>
                </div>
                <div class="lis">
                  <vue-seamless-scroll
                    :data="dataList"
                    :speed="200"
                    :loop="true"
                    :hoverStop="true"
                    :height="'246px'"
                  >
                    <ul>
                      <router-link
                        v-for="(item, index) in dataList"
                        :key="index"
                        class="scroll-item"
                        :to="'/content/' + ModeTab + '/' + item.cmCommentId"
                      >
                        <p class="scroll-item-title">
                          {{ item.commentTitle }}
                        </p>
                        <p class="scroll-item-time" v-if="item.releaseTime">
                          {{ item.releaseTime.split(" ")[0] }}
                        </p>
                      </router-link>
                    </ul>
                  </vue-seamless-scroll>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="section section4"
          :class="{ active: fullpage.current == 4 }"
        >
          <div class="main">
            <div class="byteStandard content-item-block">
              <div class="title">
                <div class="cont_tit">
                  <p>招聘公告</p>
                  <span>Recruitment Announcement</span>
                </div>
              </div>
              <div class="p_list">
                <div
                  class="cbox-5 p_loopitem"
                  v-for="(item, index) in barPictureList"
                  :key="index"
                >
                  <div class="e_image s_img">
                    <a :href="item.url" target="_blank">
                      <img
                        :src="item.objectKey"
                        alt=""
                        :title="item.text"
                        la="la"
                        needthumb="false"
                        :class="{ 'zoomed-in': index == pictureIndex }"
                      />
                      <p
                        class="text"
                        @mouseenter="zoomImage(index)"
                        @mouseleave="resetImage"
                      >
                        {{ item.text }}
                      </p>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="section section5"
          :class="{ active: fullpage.current == 5 }"
        >
          <div class="main">
            <div class="byteStandard content-item-block">
              <div class="title">
                <div class="cont_tit">
                  <p>活动专区</p>
                  <span>Recruitment Announcement</span>
                </div>
              </div>

              <div class="carousel-container">
                <div class="carousel" ref="carousel">
                  <div
                    class="carousel-track"
                    :style="{ transform: `translateX(-${currentPosition}px)` }"
                  >
                    <div
                      v-for="(slide, index) in slides"
                      :key="index"
                      class="carousel-slide"
                    >
                      <div
                        class="card"
                        :class="{ active: index == slideIndex }"
                        @mouseenter="slideenter(index)"
                        @mouseleave="slideleave"
                      >
                        <a :href="slide.url" target="_blank" v-if="slide.url">
                          <img
                            :src="slide.src"
                            :alt="slide.title"
                            class="card-image"
                          />
                          <div class="card-content">
                            <h3 class="card-title">{{ slide.title }}</h3>
                          </div>
                        </a>
                        <!-- <router-link
                          :to="{
                            path: '/events',
                            query: { id: slide.id, title: slide.title },
                          }"
                          v-else
                        > -->
                        <a
                          :href="
                            'https://www.jobhb.com/events?id=' +
                            slide.id +
                            '&title=' +
                            slide.title
                          "
                          target="_blank"
                          v-else
                        >
                          <img
                            :src="slide.src"
                            :alt="slide.title"
                            class="card-image"
                          />
                          <div class="card-content">
                            <h3 class="card-title">{{ slide.title }}</h3>
                            <!-- <p class="card-subtitle" v-if="slide.subtitle">
                            {{ slide.subtitle }}
                          </p> -->
                          </div>
                        </a>
                        <!-- </router-link> -->
                      </div>
                    </div>
                  </div>
                </div>

                <button
                  class="nav-button prev"
                  @click="prev"
                  :disabled="currentIndex === 0"
                >
                  <i class="arrow left"></i>
                </button>
                <button
                  class="nav-button next"
                  @click="nexta"
                  :disabled="currentIndex >= slides.length - slidesToShow"
                >
                  <i class="arrow right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          class="section section6"
          :class="{ active: fullpage.current == 6 }"
        >
          <div class="main">
            <div class="job-category content-item-block">
              <div class="title">
                <div class="cont_tit">
                  <p>职位推荐</p>
                  <span>Job Recommendation</span>
                </div>
                <div class="crumb">
                  <a :href="'https://www.jobhb.com/jobs'" target="_blank">
                    <!-- <router-link class="right-bar-text" to="/jobs"> -->
                    更多职位>
                    <!-- </router-link> -->
                  </a>
                </div>
              </div>
              <ul class="job-tab">
                <li
                  class="tab-item"
                  :class="{ 'item--active': Mode === 'tab1' }"
                  @click="toggleLoginMode('tab1')"
                >
                  热门职位
                </li>
                <li
                  class="tab-item"
                  :class="{ 'item--active': Mode === 'tab2' }"
                  @click="toggleLoginMode('tab2')"
                >
                  最新职位
                </li>
              </ul>
              <ul class="job-content">
                <div v-if="Mode == 'tab1'">
                  <li
                    class="recommend-job-item"
                    v-for="(item, index) in hotPositionList"
                    :key="index"
                  >
                    <div class="job-top-container">
                      <a
                        :href="'https://www.jobhb.com/jobDetail/' + item.jobId"
                        target="_blank"
                      >
                        <!-- <router-link :to="'/jobDetail/' + item.jobId"> -->
                        <div class="job-top">
                          <div class="job-name">
                            {{ item.job }}
                          </div>
                          <div class="wage">{{ item.startSalary }}</div>
                        </div>
                        <div class="job-bottom substring">
                          <span class="tag" v-if="item.workingPlace">{{
                            item.workingPlace
                          }}</span
                          ><span class="tag" v-if="item.educationName">{{
                            item.educationName
                          }}</span
                          ><span class="tag" v-if="item.serviceName">{{
                            item.serviceName
                          }}</span>
                        </div>
                        <!-- </router-link> -->
                      </a>
                    </div>
                    <div class="company-bottom">
                      <div class="company-desc">
                        <a
                          :href="
                            'https://www.jobhb.com/companyDetail/' +
                            item.companyId
                          "
                          target="_blank"
                        >
                          <!-- <router-link :to="'/companyDetail/' + item.companyId"> -->
                          <div class="company-name substring">
                            {{ item.companyName }}
                          </div>
                          <!-- </router-link> -->
                        </a>
                      </div>
                    </div>
                  </li>
                </div>
                <div v-else-if="Mode == 'tab2'">
                  <li
                    class="recommend-job-item"
                    v-for="(item, index) in latestPositionList"
                    :key="index"
                  >
                    <div class="job-top-container">
                      <a
                        :href="'https://www.jobhb.com/jobDetail/' + item.jobId"
                        target="_blank"
                      >
                        <!-- <router-link :to="'/jobDetail/' + item.jobId"> -->
                        <div class="job-top">
                          <div class="job-name">
                            {{ item.job }}
                          </div>
                          <div class="wage">{{ item.startSalary }}</div>
                        </div>
                        <div class="job-bottom substring">
                          <span class="tag" v-if="item.workingPlace">{{
                            item.workingPlace
                          }}</span
                          ><span class="tag" v-if="item.educationName">{{
                            item.educationName
                          }}</span
                          ><span class="tag" v-if="item.serviceName">{{
                            item.serviceName
                          }}</span>
                        </div>
                        <!-- </router-link> -->
                      </a>
                    </div>
                    <div class="company-bottom">
                      <div class="company-desc">
                        <a
                          :href="
                            'https://www.jobhb.com/companyDetail/' +
                            item.companyId
                          "
                          target="_blank"
                        >
                          <!-- <router-link :to="'/companyDetail/' + item.companyId"
                          > -->
                          <div class="company-name substring">
                            {{ item.companyName }}
                          </div>
                          <!-- </router-link> -->
                        </a>
                      </div>
                    </div>
                  </li>
                </div>
              </ul>
            </div>
          </div>
        </div>
        <div
          class="section section7"
          :class="{ active: fullpage.current == 7 }"
        >
          <div class="main">
            <div class="company-category content-item-block">
              <div class="title">
                <div class="cont_tit">
                  <p>热门单位</p>
                  <span>Hot Unit</span>
                </div>
                <div class="crumb">
                  <a :href="'https://www.jobhb.com/companys'" target="_blank">
                    <!-- <router-link class="right-bar-text" to="/companys"> -->
                    更多单位>
                    <!-- </router-link> -->
                  </a>
                </div>
              </div>
              <ul class="company-content">
                <li
                  class="recommend-job-item"
                  v-for="(item, index) in hotCompanyList"
                  :key="index"
                >
                  <div class="company-bottom company-item">
                    <!-- <img
                src="https://iguopin-company.oss-cn-beijing.aliyuncs.com/10685379671379573/logo/20230619/16bfc9fe61492ed18920f2ca9d44f003.jpg"
                alt="LOGO"
                class="company-logo-box"
              /> -->
                    <div class="company-desc">
                      <a
                        :href="
                          'https://www.jobhb.com/companyDetail/' +
                          item.company.reCompanyId
                        "
                        target="_blank"
                      >
                        <!-- <router-link
                        :to="'/companyDetail/' + item.company.reCompanyId"
                        > -->
                        <div class="company-name substring">
                          {{ item.company.reCompanyName }}
                        </div>
                        <div class="company-tag substring">
                          <span class="tag" v-if="item.company.industry">{{
                            item.company.industry
                          }}</span
                          ><span
                            class="tag"
                            v-if="item.company.enterpriseNature"
                            >{{ item.company.enterpriseNature }}</span
                          ><span
                            class="tag"
                            v-if="item.company.enterpriseScale"
                            >{{ item.company.enterpriseScale }}</span
                          >
                          <span class="tag" v-if="item.company.groupName">{{
                            item.company.groupName
                          }}</span>
                        </div>
                        <!-- </router-link> -->
                      </a>
                    </div>
                  </div>
                  <div
                    class="job-top-container job-item"
                    v-for="(ite, index) in item.jobsList.slice(0, 2)"
                    :key="index"
                  >
                    <a
                      :href="'https://www.jobhb.com/jobDetail/' + item.jobId"
                      target="_blank"
                    >
                      <!-- <router-link :to="'/jobDetail/' + ite.jobId"> -->
                      <div class="job-top">
                        <div class="job-name">
                          {{ ite.job }}
                        </div>
                        <div class="wage">{{ ite.startSalary }}</div>
                      </div>
                      <div class="job-bottom substring">
                        <span class="tag" v-if="ite.workingPlace">{{
                          ite.workingPlace
                        }}</span
                        ><span class="tag" v-if="ite.educationName">{{
                          ite.educationName
                        }}</span
                        ><span class="tag" v-if="ite.serviceName">{{
                          ite.serviceName
                        }}</span>
                      </div>
                      <!-- </router-link> -->
                    </a>
                  </div>
                  <a
                    :href="
                      'https://www.jobhb.com/companyDetail/' +
                      item.company.reCompanyId
                    "
                    target="_blank"
                    class="link-type"
                  >
                    <!-- <router-link
                    class="link-type"
                    :to="'/companyDetail/' + item.company.reCompanyId"> -->
                    更多职位
                    <!-- </router-link> -->
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="section section8">
          <Footer @son="getValue"></Footer>
        </div>
      </div>
    </div>

    <div
      class="nav"
      :class="{ untop: flag }"
      @mouseover="handleMouseOverTab"
      @mouseout="handleMouseOutTab"
    >
      <ul :class="{ navTop: hide }">
        <li
          v-for="(item, i) in tabOptions"
          :key="i"
          @click="handleTab(item.value)"
        >
          <span :class="{ selected: fullpage.current == item.value }">{{
            item.label
          }}</span>
        </li>
        <li class="top untop" id="idTop" @click="handleToTop">
          <span style="color: #3366cc; font-weight: bold">返回顶部</span>
        </li>
      </ul>
      <div class="tx" :class="top ? 'tx-active' : ''"></div>
    </div>

    <el-dialog
      :title="title"
      :visible.sync="open"
      width="300px"
      append-to-body
      :before-close="cancel"
      :close-on-click-modal="false"
    >
      <div class="dialog-login" v-loading="loading">
        <div style="margin-bottom: 20px" class="link-type">
          {{ countdown }} 秒后二维码失效
        </div>
        <img class="image" :src="mapSrc" alt="" />
        <div style="margin-top: 20px">
          <el-button type="text" class="link-type" @click="onRefresh"
            >刷新二维码后，重新扫码登录</el-button
          >
        </div>
      </div>
    </el-dialog>

    <Verify
      @success="success"
      :mode="'pop'"
      :captchaType="captchaType"
      :imgSize="{ width: '330px', height: '155px' }"
      ref="verify"
    ></Verify>
  </div>
</template>

<script>
// @ is an alias to /src
import {
  getUnlimitedQRCode,
  checkSceneLoginStatus,
  getBannerList,
  getBarPictureList,
  getCommentListWithPage,
  getPreviewUrl,
  sendCode,
  verifyCodeLogin,
  passwordLogin,
  getIndustryTree,
  getLatestPositionList,
  getHotPositionList,
  getHotCompanyList,
  personalInfo,
  personalInfoCommit,
  getRegionList,
} from "@/api/index.js";
import COS from "cos-js-sdk-v5";
import store from "@/store";
import { getToken, setToken } from "@/helper/auth";
import Verify from "./../components/verifition/Verify";
import { encryptSm4 } from "@/helper/sm4";
export default {
  name: "home",
  metaInfo: {
    title: "湖北人才网_招聘引才_考试测评_人才培训_管理咨询",
    meta: [
      { charset: "utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      { hid: "description", name: "description", content: "网站首页" },
      {
        name: "keywords",
        content:
          "湖北人才网, 湖北省人才集团, 湖北省人才发展集团, 湖北省人才发展集团有限公司",
      },
    ],
  },
  components: {
    Verify,
  },
  data() {
    return {
      URL: "/prod-api",
      mapSrc: "",
      scene: "",
      open: false,
      title: "微信登录",
      countdown: 300,
      pollTimer: "",
      timer: null,
      fullpage: {
        current: 1, // 当前的页面编号
        isScrolling: false, // 是否在滚动,是为了防止滚动多页，需要通过一个变量来控制是否滚动
        deltaY: 0, // 返回鼠标滚轮的垂直滚动量，保存的鼠标滚动事件的deleteY,用来判断是往下还是往上滚
        state: "",
      },
      startTime: undefined, // 记录触摸开始的时间
      startX: undefined, // 记录触摸开始的X坐标，本次主要实现的是上下滑动，所以当前坐标不做强制要求
      startY: undefined, // 记录触摸开始的Y坐标
      state: store.state,
      show: false,
      loading: false,
      //行业
      menuList: [],
      selectedIndex: null,
      //大图
      bannerList: [],
      //公告图
      comment: {},
      dataList: [],
      scrollClass: {
        "scroll-item": true,
      },
      //条形图
      barPictureList: [],
      pictureIndex: null,
      //最热岗位
      hotPositionList: [],
      //最新岗位
      latestPositionList: [],
      //热门单位
      hotCompanyList: [],
      currentTab: "tab1",
      Mode: "tab1",
      captchaType: "",
      valiBtn: "获取验证码",
      disabled: false,
      userForm: {
        phoneNumber: "",
        verifyCode: "",
        userPassword: "",
      },
      userRules: {
        phoneNumber: [
          {
            required: true,
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入请输入合法的手机号",
            trigger: "blur",
          },
        ],
        verifyCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
        userPassword: [
          { required: true, trigger: "blur", message: "请输入您的密码" },
          {
            min: 8,
            max: 16,
            message: "用户密码长度必须介于 8 和 16 之间",
            trigger: "blur",
          },
          {
            pattern:
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~!@#$%^&*()-+_=,.])[a-zA-Z\d~!@#$%^&*()-+_=,.]{8,16}$/,
            message: "密码必须包含大小写字母，数字，特殊符号",
            trigger: "blur",
          },
        ],
      },
      queryFilter: {
        pageNum: 1,
        pageSize: 10,
        typeIdArr: "1",
        visible: "1",
        orderByColumn: "releaseTime",
        isAsc: "desc",
      },
      // 注册开关
      register: true,
      ModeTab: "1",
      tabs: ["集团动态", "招聘公告", "考试通知", "党建文化"],
      tabOptions: [
        {
          value: 1,
          label: "",
        },
        {
          value: 2,
          label: "导航",
        },
        {
          value: 3,
          label: "新闻中心",
          disabled: true,
        },
        {
          value: 4,
          label: "招聘公告",
        },
        {
          value: 5,
          label: "活动专区",
        },
        {
          value: 6,
          label: "职位推荐",
        },
        {
          value: 7,
          label: "热门单位",
        },
      ],
      hide: false,
      flag: false,
      top: false,
      currentIndex: 0,
      currentPosition: 0,
      slidesToShow: 3,
      slideWidth: 0,
      slideIndex: "",
      slides: [],
    };
  },
  mounted() {
    this.calculateSlideWidth();
    window.addEventListener("resize", this.calculateSlideWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calculateSlideWidth);
  },
  created() {
    this.BannerList();
    this.IndustryTree();
    this.CommentList();
    this.BarPictureList();
    this.HotPositionList();
    this.LatestPositionListe();
    this.HotCompanyList();
    this.RegionList();
    this.getPersonalInfo();
  },
  methods: {
    //随机生成32位动态码
    generateRandomString(length) {
      const characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let result = "";
      const charactersLength = characters.length;
      for (let i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },

    //刷新二维码
    onRefresh() {
      this.countdown = 300;
      clearInterval(this.pollTimer);
      clearInterval(this.timer);
      this.getShow();
    },

    //打开二维码弹窗
    getShow() {
      this.scene = this.generateRandomString(32);
      this.open = true;
      this.loading = true;
      this.UnlimitedQRCode();
      this.startCountdown();
      this.startPolling();
    },
    //获取二维码图片
    UnlimitedQRCode() {
      getUnlimitedQRCode(this.scene).then((res) => {
        this.loading = false;
        let blob = new Blob([res]); // 返回的文件流数据
        let url = window.URL.createObjectURL(blob); // 将他转化为路径
        this.mapSrc = url; // 将转换出来的路径赋值给变量，其实和上一步结合就可以
      });
    },

    //二维码失效计时器
    startCountdown() {
      this.timer = setInterval(() => {
        if (this.countdown <= 0) {
          clearInterval(this.timer);
          this.$message.warning("二维码已过期");
          return;
        }
        this.countdown--;
      }, 1000);
    },

    //轮询查询是否扫描登入成功
    async startPolling() {
      const poll = async () => {
        try {
          await checkSceneLoginStatus(this.scene).then((res) => {
            console.log(res);
            if (res.code == 200) {
              clearInterval(this.pollTimer);
              clearInterval(this.timer);
              setToken(res.data.token);
              store.setLoginStatus("true");
              store.setPhoneNumber(res.data.phoneNumber);
              this.$message({
                showClose: true,
                message: "登录成功",
                type: "success",
              });
              this.getPersonalInfo();
              this.open = false;
            }
          });
        } catch (error) {
          console.error("轮询异常:", error);
        }
      };

      this.pollTimer = setInterval(poll, 3000);
      poll(); // 立即执行第一次
    },

    // 取消弹窗
    cancel() {
      this.open = false;
      this.countdown = 300;
      clearInterval(this.pollTimer);
      clearInterval(this.timer);
    },

    getValue(value) {
      this.fullpage.state = value;
    },
    // 往下切换
    next() {
      let len = 8; // 页面的个数
      if (this.fullpage.current + 1 <= len) {
        // 如果当前页面编号+1 小于总个数，则可以执行向下滑动
        this.fullpage.current += 1; // 页面+1
        this.move(this.fullpage.current); // 执行切换
      }
    },
    // 往上切换
    pre() {
      if (this.fullpage.current - 1 > 0) {
        // 如果当前页面编号-1 大于0，则可以执行向下滑动
        this.fullpage.current -= 1; // 页面+1
        this.move(this.fullpage.current); // 执行切换
      }
    },
    // 滚动事件
    move(index) {
      this.fullpage.isScrolling = true; // 为了防止滚动多页，需要通过一个变量来控制是否滚动
      this.directToMove(index); //执行滚动
      setTimeout(() => {
        //这里的动画是1s执行完，使用setTimeout延迟1s后解锁
        this.fullpage.isScrolling = false;
      }, 500);
    },
    // 执行滚动
    directToMove(index) {
      let height = this.$refs["fullPage"].clientHeight; //获取屏幕的宽度
      let scrollPage = this.$refs["fullPageContainer"]; // 获取执行tarnsform的元素
      let scrollHeight; // 计算滚动的告诉，是往上滚还往下滚
      if (index < 8) {
        scrollHeight = -(index - 1) * height + "px";
        scrollPage.style.transform = `translateY(${scrollHeight})`;
      } else {
        scrollHeight = -(index - 2) * height - 470 + "px";
        scrollPage.style.transform = `translateY(${scrollHeight})`;
      }
      this.fullpage.current = index;
      if (this.fullpage.current == 1) {
        this.flag = false;
      } else {
        this.flag = true;
      }
    },
    // 监听鼠标监听
    mouseWheelHandle(event) {
      // 添加冒泡阻止
      let evt = event || window.event;
      if (evt.stopPropagation) {
        evt.stopPropagation();
      } else {
        evt.returnValue = false;
      }
      if (this.fullpage.isScrolling) {
        // 判断是否可以滚动
        return false;
      }
      let e = event.originalEvent || event;
      this.fullpage.deltaY = e.deltaY || e.detail; // Firefox使用detail
      if (this.fullpage.deltaY > 0 && !this.fullpage.state) {
        this.next();
      } else if (this.fullpage.deltaY < 0 && !this.fullpage.state) {
        this.pre();
      }
    },
    // 清除触摸事件
    handleTouchmove(event) {
      event.preventDefault();
    },
    //手指按下屏幕
    handleTouchstart(event) {
      this.startTime = Date.now();
      this.startX = event.changedTouches[0].clientX;
      this.startY = event.changedTouches[0].clientY;
    },
    //手指离开屏幕
    handleTouchend(event) {
      const endTime = Date.now();
      const endX = event.changedTouches[0].clientX;
      const endY = event.changedTouches[0].clientY;
      //判断按下的时长
      if (endTime - this.startTime > 2000) {
        return;
      }
      //滑动的方向
      let direction = "";
      //先判断用户滑动的距离，是否合法，合法:判断滑动的方向 注意 距离要加上绝对值
      if (Math.abs(endY - this.startY) > 10) {
        //滑动方向
        direction = endY - this.startY > 0 ? "down" : "up";
      } else {
        return;
      }
      //用户做了合法的滑动操作
      if (direction === "up") {
        this.next();
      }
      if (direction === "down") {
        this.pre();
      }
    },

    //切换屏
    handleTab(index) {
      this.fullpage.current = index;
      this.move(this.fullpage.current);
      this.top = true;
      setTimeout(() => {
        this.top = false;
      }, 1000);
    },

    //返回顶部
    handleToTop() {
      this.fullpage.current = 1;
      this.move(this.fullpage.current);
      this.top = true;
      setTimeout(() => {
        this.top = false;
      }, 1000);
    },

    //移入
    handleMouseOverTab() {
      this.hide = true;
    },
    //移出
    handleMouseOutTab() {
      this.hide = false;
    },

    //行业
    IndustryTree() {
      getIndustryTree().then((response) => {
        if (response.code == 200) {
          this.menuList = this.transListDataToTreeData(response.data, "0");
        }
      });
    },

    transListDataToTreeData(list, root) {
      const arr = [];
      // 1.遍历
      list.forEach((item) => {
        // 2.首次传入空字符串  判断list的pid是否为空 如果为空就是一级节点
        if (item.pid === root) {
          // 找到之后就要去找item下面有没有子节点  以 item.id 作为 父 id, 接着往下找
          const children = this.transListDataToTreeData(
            list,
            item.reIndustryTreeId
          );
          if (children.length > 0) {
            // 如果children的长度大于0,说明找到了子节点
            item.children = children;
          }
          // 将item项, 追加到arr数组中
          arr.push(item);
        }
      });
      return arr;
    },

    //移入
    handleMouseOver(index) {
      this.selectedIndex = index;
    },

    //移出
    handleMouseOut() {
      this.selectedIndex = null;
    },

    calculateSlideWidth() {
      const containerWidth = this.$refs.carousel.clientWidth;
      this.slidesToShow = window.innerWidth < 768 ? 1 : 3;
      this.slideWidth = containerWidth / this.slidesToShow;
      this.updatePosition();
    },
    updatePosition() {
      this.currentPosition = this.currentIndex * this.slideWidth;
    },
    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.updatePosition();
      }
    },
    nexta() {
      if (this.currentIndex < this.slides.length - this.slidesToShow) {
        this.currentIndex++;
        this.updatePosition();
      }
    },

    //专区列表
    RegionList() {
      getRegionList().then((res) => {
        if (res.code == 200) {
          res.data.forEach((item) => {
            this.PreviewUrlRegion(item);
          });
        }
      });
    },

    PreviewUrlRegion(item) {
      getPreviewUrl(item.webRegionPic).then((response) => {
        this.slides.push({
          id: item.reRegionId,
          src: response.msg,
          url: item.webRegionUrl,
          title: item.regionName,
          num: item.count,
        });
      });
    },

    //移入
    slideenter(index) {
      this.slideIndex = index;
    },

    //移出
    slideleave() {
      this.slideIndex = null;
    },

    //最热岗位
    HotPositionList() {
      getHotPositionList().then((response) => {
        if (response.code == 200) {
          this.hotPositionList = response.data;
        }
      });
    },

    //最新岗位
    LatestPositionListe() {
      getLatestPositionList().then((response) => {
        if (response.code == 200) {
          this.latestPositionList = response.data;
        }
      });
    },

    //最热单位
    HotCompanyList() {
      getHotCompanyList().then((response) => {
        if (response.code == 200) {
          this.hotCompanyList = response.data;
        }
      });
    },

    //获取大图
    BannerList() {
      getBannerList().then((response) => {
        response.data.forEach((item) => {
          if (item.visible == 1) {
            this.PreviewUrl(item);
          }
        });
      });
    },

    toggleLoginModeTab(mode) {
      this.ModeTab = mode;
      this.queryFilter.typeIdArr = mode;
      this.CommentList();
    },

    //获取公告
    CommentList() {
      getCommentListWithPage(this.queryFilter).then((res) => {
        if (res.code == 200) {
          this.dataList = res.rows;
          if (res.rows[0].objectKey) {
            this.PreviewUrl1(res.rows[0]);
          }
        }
      });
    },

    //获取条形图
    async BarPictureList() {
      await getBarPictureList().then((response) => {
        response.data.forEach(async (item, i) => {
          if (item.visible == 1) {
            this.barPictureList.push({
              url: item.url,
              text: item.text,
              objectKey: "",
              visible: item.visible,
            });
            await this.PreviewUrl2(item, i);
          }
        });
      });
    },

    //移入
    zoomImage(index) {
      this.pictureIndex = index;
    },

    //移出
    resetImage() {
      this.isZoomed = null;
    },

    PreviewUrl(item) {
      getPreviewUrl(item.objectKey).then((response) => {
        this.bannerList.push({
          objectKey: response.msg,
          customUrl: item.customUrl,
          visible: item.visible,
        });
      });
    },

    PreviewUrl1(item) {
      getPreviewUrl(item.objectKey).then((response) => {
        this.comment = item;
        this.comment.objectKey = response.msg;
      });
    },

    async PreviewUrl2(item, i) {
      await getPreviewUrl(item.objectKey).then((response) => {
        this.barPictureList[i].objectKey = response.msg;
      });
    },

    toggleLoginMode(mode) {
      this.Mode = mode;
    },

    success(params) {
      // params 返回的二次验证参数, 和登录参数一起回传给登录接口，方便后台进行二次验证
      this.tackBtn(); //验证码倒数60秒
      this.$set(params, "phoneNumber", this.userForm.phoneNumber);
      sendCode(params).then((res) => {});
    },

    //获取验证码 并只验证手机号 是否正确
    getVerifyCode() {
      let isValid = true;
      this.$refs["userForm"].validateField(["phoneNumber"], (err) => {
        if (err) {
          isValid = false;
          console.log("未通过");
          return;
        } else {
          console.log("已通过");
        }
      });
      if (isValid) {
        this.captchaType = Math.random() < 0.5 ? "blockPuzzle" : "clickWord";
        this.$refs.verify.show();
      }
    },

    tackBtn() {
      //验证码倒数60秒
      let time = 60;
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer);
          this.valiBtn = "获取验证码";
          this.disabled = false;
        } else {
          this.disabled = true;
          this.valiBtn = time + "秒后重试";
          time--;
        }
      }, 1000);
    },

    //切换登录方式
    getClick() {
      this.show = !this.show;
    },

    //验证码登录
    handleUserLogin() {
      this.$refs.userForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          verifyCodeLogin(
            this.userForm.phoneNumber,
            encryptSm4(this.userForm.verifyCode)
          )
            .then((res) => {
              if (res.code == 200) {
                setToken(res.data.token);
                store.setLoginStatus("true");
                store.setPhoneNumber(res.data.phoneNumber);
                this.$message({
                  showClose: true,
                  message: "登录成功",
                  type: "success",
                });
                this.getPersonalInfo();
                this.loading = false;
              } else {
                this.$message({
                  showClose: true,
                  message: res.msg,
                  type: "warning",
                });
                this.loading = false;
              }
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },

    //密码登录
    handleRecord() {
      this.$refs.userForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          passwordLogin(
            this.userForm.phoneNumber,
            encryptSm4(this.userForm.userPassword)
          )
            .then((res) => {
              if (res.code == 200) {
                setToken(res.data.token);
                store.setLoginStatus("true");
                store.setPhoneNumber(res.data.phoneNumber);
                this.$message({
                  showClose: true,
                  message: "登录成功",
                  type: "success",
                });
                this.getPersonalInfo();
                this.loading = false;
              } else {
                this.$message({
                  showClose: true,
                  message: res.msg,
                  type: "warning",
                });
                this.loading = false;
              }
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },

    //获取个人信息
    getPersonalInfo() {
      if (getToken()) {
        personalInfo().then((res) => {
          if (res.code == 200) {
            if (res.data.reMiniProgramPerson) {
              store.setUserName(res.data.reMiniProgramPerson.realName);
              store.setMiniProgramPersonId(
                res.data.reMiniProgramPerson.miniProgramPersonId
              );
              if (res.data.reMiniProgramPerson.profilePhoto) {
                this.PreviewUrlPhoto(res.data.reMiniProgramPerson.profilePhoto);
              }
            }
          }
        });
      }
    },

    //获取头像
    PreviewUrlPhoto(profilePhoto) {
      getPreviewUrl(profilePhoto).then((response) => {
        store.setProfilePhoto(response.msg);
      });
    },

    //上传头像
    handleFileChange(event) {
      const input = event.target;
      if (input.files.length > 0) {
        let types = input.files[0].name.split(".")[1];
        const files = input.files[0];
        let filesSize = files.size;
        if (filesSize / (1024 * 1024) < 1) {
          this.uploads(files, types);
        } else {
          this.$message({
            type: "warning",
            message: "文件过大，建议不要超过1M！",
          });
        }
      }
    },

    //loading
    showLoading() {
      this.load = this.$loading({
        lock: true,
        text: "上传中",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },

    generateUUID() {
      var d = new Date().getTime(); //Timestamp
      var d2 =
        (performance && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = Math.random() * 16; //random number between 0 and 16
          if (d > 0) {
            //Use timestamp until depleted
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
          } else {
            //Use microseconds since page-load if supported
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
          }
          return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
    },

    //上传
    uploads(files, types) {
      let _this = this;
      _this.showLoading();
      let uuid = _this.generateUUID();
      let objectKey = "微信招聘小程序/头像/" + uuid + "." + types;
      // 初始化实例
      const cos = new COS({
        // getAuthorization 必选参数
        getAuthorization: function (options, callback) {
          const url = _this.URL + "/api/miniProgram/getCosAuth";
          const xhr = new XMLHttpRequest();
          xhr.open("get", url, true);
          xhr.onload = function (e) {
            let data = JSON.parse(xhr.response).data;
            let timestamp = Math.floor(data.startTime / 1000);
            callback({
              TmpSecretId: data.tmpSecretId,
              TmpSecretKey: data.tmpSecretKey,
              SecurityToken: data.sessionToken,
              StartTime: timestamp, // 时间戳，单位秒，如：1580000000
              ExpiredTime: timestamp + 60, // 时间戳，单位秒，如：1580000000
            });
          };
          xhr.send();
        },
      });

      cos.uploadFile(
        {
          Bucket: "zhaopin-1322091753" /* 填写自己的 bucket，必须字段 */,
          Region: "ap-nanjing" /* 存储桶所在地域，必须字段 */,
          Key: objectKey /* 存储在桶里的对象键（例如:1.jpg，a/b/test.txt，图片.jpg）支持中文，必须字段 */,
          Body: files, // 上传文件对象
          SliceSize:
            1024 *
            1024 *
            10 /* 触发分块上传的阈值，超过5MB使用分块上传，小于5MB使用简单上传。可自行设置，非必须 */,
          onProgress: function (progressData) {
            console.log(JSON.stringify(progressData));
          },
        },
        function (err, data) {
          if (err) {
            _this.load.close();
            _this.$message.error("上传失败");
          } else {
            let obj = {
              miniProgramPersonId: _this.state.miniProgramPersonId,
              profilePhoto: objectKey,
            };
            personalInfoCommit(obj)
              .then((res) => {
                if (res.code == 200) {
                  _this.load.close();
                  _this.getPersonalInfo();
                  _this.$message({
                    type: "success",
                    message: "上传成功!",
                  });
                } else {
                  _this.load.close();
                  _this.$message(res.msg);
                }
              })
              .catch(() => {
                _this.load.close();
              });
          }
        }
      );
    },
  },
};
</script>

<style lang="less" scoped>
@keyframes verticalMotion {
  0% {
    transform: translateY(6px);
  }
  50% {
    transform: translateY(-6px);
  }
  100% {
    transform: translateY(6px);
  }
}
@keyframes scrollToRight {
  0% {
    left: -100%;
  }

  100% {
    left: 100%;
  }
}

@keyframes fadeIndown {
  0% {
    opacity: 0;
    transform: translateY(-50%);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(50%);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInRight {
  0% {
    opacity: 0;
    transform: translateX(50%);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

::v-deep .el-card__body {
  padding: 0 20px;
}

.dialog-login {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .image {
    width: 200px;
  }
}

.fullPage {
  height: calc(100vh - 80px); //一定要设置，保证占满
  overflow: hidden; //一定要设置，多余的先隐藏
  // background-color: rgb(189, 211, 186);
}

.fullPageContainer {
  width: 100%;
  height: calc(100vh - 80px);
  transition: all linear 0.5s;
}

.section {
  width: 100%;
  height: calc(100vh - 80px);
  background-position: center center;
  background-repeat: no-repeat;
  overflow: hidden;
}

.section4 {
  background: url(../assets/images/index04_bg.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.section5 {
  background: url(../assets/images/index05_bg.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.section6 {
  background: url(../assets/images/index07_bg.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.section7 {
  background: url(../assets/images/index_07_bac.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.section8 {
  overflow: visible;
}

.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .cont_tit {
    position: relative;
    font-weight: 800;
  }

  .cont_tit:after {
    content: "";
    position: absolute;
    background: url("../assets/images/index20231114_8.png") center center
      no-repeat;
    background-size: 100% auto;
    width: 450px;
    height: 56px;
    left: -10px;
    bottom: -30px;
  }

  .cont_tit p {
    display: inline-block;
    font-size: 30px;
    padding-right: 20px;
    line-height: 1.1;
    position: relative;
    margin-right: 20px;
    font-weight: 600;
    color: #335593;
  }

  .cont_tit p:after {
    content: "";
    position: absolute;
    height: 28px;
    width: 3px;
    left: 100%;
    bottom: 0;
    background: #7499ce;
  }

  .cont_tit span {
    display: inline-block;
    font-size: 14px;
    color: #b1b1b1;
  }

  .crumb {
    color: #585858;
    font-size: 18px;
    .right-bar-text {
      margin: 0 10px;
      display: inline-block;
    }
  }
}

//动态效果
.active .cont_tit,
.active .crumb,
.active .cbox-5:nth-child(even),
.active .recommend-job-item:nth-child(even) {
  -webkit-animation-duration: 1s;
  -moz-animation-duration: 1s;
  -o-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-name: fadeIndown;
  -moz-animation-name: fadeIndown;
  -o-animation-name: fadeIndown;
  animation-name: fadeIndown;
  -webkit-animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -o-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-timing-function: ease-in-out;
  -moz-animation-timing-function: ease-in-out;
  -o-animation-timing-function: ease-in-out;
  animation-timing-function: ease-in-out;
}

.active .banner-left {
  -webkit-animation-duration: 0.8s;
  -moz-animation-duration: 0.8s;
  -o-animation-duration: 0.8s;
  animation-duration: 0.8s;
  -webkit-animation-name: fadeInUp;
  -moz-animation-name: fadeInUp;
  -o-animation-name: fadeInUp;
  animation-name: fadeInUp;
  -webkit-animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -o-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-timing-function: ease-in-out;
  -moz-animation-timing-function: ease-in-out;
  -o-animation-timing-function: ease-in-out;
  animation-timing-function: ease-in-out;
}

.active .banner-center,
.active .left_cont,
.active .cbox-5:nth-child(odd),
.active .job-tab,
.active .recommend-job-item:nth-child(odd) {
  -webkit-animation-duration: 1s;
  -moz-animation-duration: 1s;
  -o-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-name: fadeInUp;
  -moz-animation-name: fadeInUp;
  -o-animation-name: fadeInUp;
  animation-name: fadeInUp;
  -webkit-animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -o-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-timing-function: ease-in-out;
  -moz-animation-timing-function: ease-in-out;
  -o-animation-timing-function: ease-in-out;
  animation-timing-function: ease-in-out;
}

.active .banner-right {
  -webkit-animation-duration: 1s;
  -moz-animation-duration: 1s;
  -o-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-name: fadeInUp;
  -moz-animation-name: fadeInUp;
  -o-animation-name: fadeInUp;
  animation-name: fadeInUp;
  -webkit-animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -o-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-timing-function: ease-in-out;
  -moz-animation-timing-function: ease-in-out;
  -o-animation-timing-function: ease-in-out;
  animation-timing-function: ease-in-out;
}

.active .right_cont .tis-tab,
.active .carousel {
  -webkit-animation-duration: 1s;
  -moz-animation-duration: 1s;
  -o-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-name: fadeInRight;
  -moz-animation-name: fadeInRight;
  -o-animation-name: fadeInRight;
  animation-name: fadeInRight;
  -webkit-animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -o-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-timing-function: ease-in-out;
  -moz-animation-timing-function: ease-in-out;
  -o-animation-timing-function: ease-in-out;
  animation-timing-function: ease-in-out;
}

.active .ttxw,
.active .right_cont .lis {
  -webkit-animation-duration: 0.8s;
  -moz-animation-duration: 0.8s;
  -o-animation-duration: 0.8s;
  animation-duration: 0.8s;
  -webkit-animation-name: fadeInRight;
  -moz-animation-name: fadeInRight;
  -o-animation-name: fadeInRight;
  animation-name: fadeInRight;
  -webkit-animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -o-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-timing-function: ease-in-out;
  -moz-animation-timing-function: ease-in-out;
  -o-animation-timing-function: ease-in-out;
  animation-timing-function: ease-in-out;
}

.home {
  // padding-top: 20px;
  // background-color: rgb(242, 242, 242);
  .main {
    width: @main-width;
    margin: auto;
  }
  .content-item-block {
    .title {
      font-size: @font-size-larger;
    }
  }
}

//导航
.banner {
  min-height: 400px;
  width: @main-width;
  margin: auto;
  display: flex;
  position: relative;
  .banner-left {
    background-color: #fff;
    box-shadow: 0px 9px 20px 0px #c2c1c180;
    padding: 15px 0;
    width: 250px;
    z-index: 15;
    .category-item {
      -webkit-box-sizing: content-box;
      box-sizing: content-box;
      cursor: pointer;
      height: 25px;
      line-height: 25px;
      padding: 8px 0 8px 30px;
      .category-left {
        -ms-flex-align: center;
        align-items: center;
        display: -ms-flexbox;
        display: flex;
        font-size: 16px;
        position: relative;
        .icon-enter {
          color: #ccc;
          position: absolute;
          right: 15px;
        }
      }
      .category-content {
        background: #fff;
        box-shadow: 0px 9px 20px 0px #c2c1c180;
        border-bottom: 1px solid #f1f1f1;
        border-top: 1px solid #f1f1f1;
        height: 450px;
        left: 251px;
        padding: 0 20px;
        position: absolute;
        top: 0;
        display: none;
        width: 420px;
        .content-title {
          border-bottom: 1px solid #f1f1f1;
          color: #666;
          font-family: MicrosoftYaHei;
          font-size: 16px;
          height: 46px;
          letter-spacing: 0.22px;
          line-height: 46px;
          text-align: left;
        }
        .content-item {
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          color: #999;
          float: left;
          font-family: MicrosoftYaHei;
          font-size: 15px;
          letter-spacing: 0.19px;
          line-height: 40px;
          overflow: hidden;
          padding-left: 4px;
          text-align: left;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 33%;
          word-break: break-all;
        }
        .content-item:hover {
          color: #00a0e9;
        }
      }
      .hover-visible {
        display: block;
      }
    }

    .selected {
      color: #00a0e9;
      background-color: rgba(190, 203, 240, 0.1);
    }
  }
  .banner-center {
    margin: 0 20px;
    overflow: hidden;
    position: relative;
    background: #fff;
    box-shadow: 0px 9px 20px 0px #c2c1c180;
    width: 730px;
    .img {
      width: 730px;
      height: 450px;
    }
  }
  .banner-right {
    background-color: #fff;
    box-shadow: 0px 9px 20px 0px #c2c1c180;
    box-sizing: content-box;
    padding: 0 20px;
    width: 250px;
    display: flex;
    align-items: center;
    justify-content: center;
    .Login {
      width: 240px;
      text-align: center;
      position: relative;
      .flex-container {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        .flex-left {
          width: 120px;
          font-size: 24px;
          line-height: 40px;
          text-align: center;
          align-self: flex-start; /* 靠左对齐 */
        }

        .flex-right {
          width: 120px;
          font-size: 24px;
          line-height: 40px;
          text-align: center;
          align-self: flex-end; /* 靠右对齐 */
        }

        .active {
          line-height: 38px;
          border-bottom: 2px solid #00a0e9;
        }
      }

      .avatar {
        border-radius: 50%;
        height: 80px;
        margin-bottom: 20px;
        -o-object-fit: contain;
        object-fit: contain;
        width: 80px;
      }

      .file {
        position: absolute;
        cursor: pointer;
        opacity: 0;
        z-index: 15;
        width: 80px;
        height: 80px;
        left: 80px;
      }

      .userInfo {
        text-align: center;
        font-size: 20px;
        margin-bottom: 40px;
      }

      .link-type {
        color: #337ab7;
        font-size: 14px;
      }

      .user-tab {
        .tab-item {
          font-size: 18px;
          font-weight: 500;
          height: 42px;
          line-height: 42px;
          margin: 0;
        }
        .tab-item:hover {
          color: #00a0e9;
          background-color: rgba(190, 203, 240, 0.1);
          border-left: 3px solid #00a0e9;
        }
      }

      .login-code {
        width: 45%;
        height: 38px;
        float: right;
        margin-left: 5%;

        img {
          cursor: pointer;
          vertical-align: middle;
          width: 100%;
          height: 40px;
        }
      }
    }
  }
}

// 公告
.ttxw {
  display: flex;
  align-items: center;
  margin-bottom: 6vh;
  transition: all 1s;
  img {
    height: 3.3333vh;
    margin-right: 1.4062vw;
  }
  a {
    font-size: 2.7777vh;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.product {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 4vh;
  .left_cont {
    position: relative;
    margin-right: 4%;
    width: 56%;
    border-radius: 8px;
    overflow: hidden;
    transition: all 1s;
  }

  .left_cont img {
    width: 100%;
    height: 43vh;
  }

  .left_cont p {
    position: absolute;
    background: #00000080;
    width: 100%;
    font-size: 2.3333vh;
    padding: 1em 1.619em;
    box-sizing: border-box;
    left: 0;
    bottom: 0;
    color: #fff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .right_cont {
    width: 40%;
    .tis-tab {
      display: flex;
      justify-content: space-between;
      background: #eeeeee;
      border-radius: 8px;
      margin-bottom: 2vh;
      transition: all 1s;
      .tab-item {
        font-size: 2.3vh;
        width: 23.6886%;
        height: 5.7777vh;
        line-height: 1;
        border-radius: 8px;
        overflow: hidden;
        position: relative;
        z-index: 10;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .item--active {
        color: #fff;
      }
      .item--active:after {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        background: linear-gradient(-90deg, #cda667, #f2dd9f);
        background: #047fc3;
        top: 0;
        left: 0;
        z-index: -1;
      }
    }

    .lis {
      overflow: hidden;
      height: 36vh;
      .scroll-item {
        -webkit-animation-duration: 0.2s;
        -moz-animation-duration: 0.2s;
        -o-animation-duration: 0.2s;
        animation-duration: 0.2s;
        -webkit-animation-name: fadeInRight;
        -moz-animation-name: fadeInRight;
        -o-animation-name: fadeInRight;
        animation-name: fadeInRight;
        -webkit-animation-fill-mode: both;
        -moz-animation-fill-mode: both;
        -o-animation-fill-mode: both;
        animation-fill-mode: both;
        -webkit-animation-timing-function: ease-in-out;
        -moz-animation-timing-function: ease-in-out;
        -o-animation-timing-function: ease-in-out;
        animation-timing-function: ease-in-out;
      }

      .scroll-item {
        font-size: 1.8vh;
        display: flex;
        justify-content: space-between;
        line-height: 2.4444;
        transition: all 1s;
        .scroll-item-title {
          width: 70%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          position: relative;
          transition: 0.8s padding-left ease;
        }
      }

      .scroll-item:hover .scroll-item-title {
        padding-left: 1em;
        font-weight: bold;
        transition: 0.8s padding-left ease;
      }

      .scroll-item:hover .scroll-item-title:before {
        content: "";
        position: absolute;
        background: url("../assets/images/index20231114_11.png") center center
          no-repeat;
        width: 0.4444em;
        height: 0.6666em;
        background-size: 100% auto;
        left: 0;
        top: calc((100% - 0.6666em) / 2);
      }
    }
  }
}

//条形图
.byteStandard {
  // margin-top: 20px;
  padding: 5% 0;
  .p_list {
    display: flex;
    flex-wrap: wrap;
    position: relative;
    max-width: 100%;
    margin-top: 5%;
    .cbox-5:nth-child(odd) {
      padding-right: 4px;
      margin-bottom: 4px;
    }
    .p_loopitem {
      flex-grow: 0;
      flex-shrink: 0;
      flex-basis: calc(100% / 2);
    }
    .e_image {
      position: relative;
      width: 100%;
      height: auto;
      overflow: hidden;
      padding-bottom: 18.5%;
      transition: all 0.5s;
      transform: scale(1);
      -webkit-transform: scale(1);
      img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) scale(1);
        width: 100%;
        height: 100%;
        max-width: 100%;
        max-height: 100%;
        transition: all 0.5s ease;
        object-fit: cover;
      }
      .text {
        position: absolute;
        width: 90%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        font-size: 20px;
        color: #fff;
        font-weight: 600;
        left: 5%;
      }
      .zoomed-in {
        transform: translate(-50%, -50%) scale(1.1);
        transition: transform 0.5s ease;
      }
    }
  }
}

// 活动专区
.carousel-container {
  position: relative;
  width: 100%;
  margin-top: 5%;
  .carousel {
    width: 100%;
    overflow: inherit;
    .carousel-track {
      display: flex;
      transition: transform 0.5s ease-in-out;
      .carousel-slide {
        flex: 0 0 auto;
        width: calc(100% / 3);
        padding-right: 80px;
        .card {
          position: relative;
          border-radius: 12px;
          overflow: hidden;
          aspect-ratio: 3/4;
          transition: transform 0.5s ease;
          .card-image {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .card-content {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            padding: 20px;
            color: white;
            background: linear-gradient(
              to bottom,
              rgba(0, 0, 0, 0.7) 0%,
              rgba(0, 0, 0, 0) 100%
            );
            .card-title {
              font-size: 24px;
              font-weight: bold;
              margin: 0 0 8px 0;
            }
            .card-subtitle {
              font-size: 16px;
              margin: 0;
            }
          }
        }

        .card.active {
          transform: translate(-1%, -1%) scale(1.1);
          transition: transform 0.5s ease;
        }

        .card.green {
          background-color: #2f4f4f;
        }

        .card.red {
          background-color: #8b0000;
        }

        .card.light {
          background-color: #f8f8ff;
        }
      }
    }
  }
  .nav-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.8);
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    .arrow {
      border: solid #333;
      border-width: 0 2px 2px 0;
      display: inline-block;
      padding: 3px;
    }

    .arrow.left {
      transform: rotate(135deg);
    }

    .arrow.right {
      transform: rotate(-45deg);
    }
  }

  .nav-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .nav-button.prev {
    left: 20px;
  }

  .nav-button.next {
    right: 80px;
  }
}

// 职位
.job-category {
  text-align: center;
  padding: 5% 0;
  .job-tab {
    -ms-flex-align: center;
    -ms-flex-pack: center;
    align-items: center;
    background-color: #fff;
    box-shadow: 0px 9px 20px 0px #c2c1c180;
    border-bottom: 1px solid #e6e6e6;
    cursor: pointer;
    display: -ms-flexbox;
    display: flex;
    height: 60px;
    justify-content: center;
    line-height: 60px;
    margin-bottom: 20px;
    margin-top: 5%;
    text-align: center;
    .tab-item {
      color: #333;
      font-size: 22px;
      margin: 0 40px;
      width: 128px;
      position: relative;
    }
    .tab-item.item--active {
      color: #00a0e9;
    }
    .tab-item.item--active:after {
      background: #00a0e9;
      bottom: 0;
      content: "";
      height: 4px;
      left: calc(50% - 10px);
      position: absolute;
      width: 20px;
    }
  }
  .job-content > div {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }
}

.section-header {
  -ms-flex-align: center;
  -ms-flex-pack: justify;
  align-items: center;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-between;
  .bar {
    background-color: #00a0e9;
    height: 20px;
    margin-right: 20px;
    width: 10px;
  }
  .section-title {
    font-size: 20px;
  }
  .line {
    background-color: #ccc;
    height: 1px;
    margin-left: 40px;
    margin-right: 34px;
    width: 1048px;
  }
  .right-bar {
    -ms-flex-align: center;
    align-items: center;
    color: #999;
    cursor: pointer;
    display: -ms-flexbox;
    display: flex;
    font-size: 12px;
    .right-bar-text {
      margin-right: 4px;
    }
  }
}

.recommend-job-item:nth-child(3n) {
  margin-right: 0;
}
.recommend-job-item {
  background-color: #fff;
  box-shadow: 0px 9px 20px 0px #c2c1c180;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  margin-bottom: 21px;
  margin-right: 21px;
  padding: 13px 23px;
  width: 373px;
}

.job-top-container {
  border-bottom: 1px dotted #666;
  line-height: 30px;
  padding-bottom: 10px;
  .job-top {
    -ms-flex-align: center;
    -ms-flex-pack: justify;
    align-items: center;
    display: -ms-flexbox;
    display: flex;
    justify-content: space-between;
    .job-name {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .wage {
      flex: 1;
      justify-content: flex-end;
      display: flex;
      color: #d9011e;
      font-size: 16px;
      align-items: center;
      white-space: nowrap;
    }
  }
}

.substring {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
  text-align: left;
}
.tag {
  font-size: 14px;
}
.tag:not(:first-child):before {
  content: "|";
  margin: 0 4px;
}
.company-bottom {
  -ms-flex-align: center;
  align-items: center;
  display: -ms-flexbox;
  display: flex;
  margin-top: 5px;
  // .company-logo-box {
  //   height: 50px;
  //   margin-right: 20px;
  //   margin-top: 10px;
  //   -o-object-fit: contain;
  //   object-fit: contain;
  //   width: 50px;
  // }
  // img {
  //   border-style: none;
  //   vertical-align: middle;
  // }
  .company-desc .company-tag {
    margin-top: 10px;
    width: 303px;
  }
}

// 公司
.company-category {
  text-align: center;
  padding: 5% 0;
  // margin-top: 25px;
  .company-content {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    // margin-top: 20px;
    margin-top: 5%;
    .company-item {
      border-bottom: 1px dotted #666;
      padding-bottom: 10px;
    }
    .job-item {
      padding-top: 10px;
    }
    .link-type {
      color: #337ab7;
      margin-top: 10px;
      font-size: 16px;
      width: 150px;
      height: 40px;
      border: 1px solid #337ab7;
      border-radius: 45px;
      line-height: 40px;
      display: inline-block;
    }
  }
}

//返回顶部
.nav.untop {
  display: flex;
}
.nav {
  display: none;
  position: absolute;
  flex-direction: column;
  justify-content: center;
  width: 112px;
  bottom: 50px;
  top: auto;
  right: 3.1875em;
  z-index: 90;
  ul {
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;
    background-image: url(../assets/images/index-nav-bg.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: none;
    li {
      display: flex;
      justify-content: center;
      width: 100;
      padding: 5px 0;
      .selected {
        background-image: -webkit-linear-gradient(
          0deg,
          rgb(81, 205, 244) 0%,
          rgb(31, 111, 207) 100%
        );
        color: #fff;
        padding: 2px 10px;
        border-radius: 45px;
      }
    }
    .top {
      text-align: center;
      padding: 5px 0 30px 0;
      z-index: 1001;
    }
  }
  .navTop {
    display: block;
  }
  .tx {
    margin-top: -42px;
    margin-left: -10px;
    width: 138px;
    height: 138px;
    background-image: url(../assets/images/index-nav-tx.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .tx-active {
    background: url("../assets/images/index-nav-active.gif");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    z-index: 10;
  }
}
</style>
